import { defineModuleEvidenceContract } from './moduleEvidenceContract';
import { SGA_SPEND_SCHEMA_VERSIONS } from './schemaVersions';
import { SGA_SPEND_MODULE_EVIDENCE_CONTRACT } from './sgaSpendModuleEvidenceContract';

const sharedServicesEvidenceEntry =
  SGA_SPEND_MODULE_EVIDENCE_CONTRACT.entries.shared_services;

export const SHARED_SERVICES_STATE_KEYS = {
  governedSnapshot: sharedServicesEvidenceEntry.stateKey,
  spendAttested: 'shared_services_spend_attested',
  spendGoverned: 'shared_services_spend_governed',
  addressableAttested: 'shared_services_addressable_attested',
  addressableGoverned: 'shared_services_addressable_governed',
  programAttested: 'shared_services_program_attested',
  programGoverned: 'shared_services_program_governed',
  spendSnapshot: 'shared-services-spend-snapshot',
  addressableSnapshot: 'shared-services-addressable-snapshot',
  programSnapshot: 'shared-services-program-snapshot',
} as const;

export const SHARED_SERVICES_EVIDENCE_KEYS = {
  governedSnapshot: sharedServicesEvidenceEntry.evidenceKey,
  ingestedSnapshot: 'shared_services_snapshot',
  spendSnapshot: SHARED_SERVICES_STATE_KEYS.spendSnapshot,
  addressableSnapshot: SHARED_SERVICES_STATE_KEYS.addressableSnapshot,
  programSnapshot: SHARED_SERVICES_STATE_KEYS.programSnapshot,
  costCenterExtract: 'shared_services_cost_center_extract',
  serviceCatalogUsage: 'shared_services_service_catalog_usage',
} as const;

export const SHARED_SERVICES_BINDING_PLACEHOLDERS = {
  opportunityUsd: sharedServicesEvidenceEntry.bindingPlaceholders[0],
} as const;

export const SHARED_SERVICES_SCHEMA_VERSIONS = {
  manifest: SGA_SPEND_SCHEMA_VERSIONS.manifest,
  governedSnapshot: sharedServicesEvidenceEntry.schemaVersion,
  contextPack: 'decision_agent_context_pack_v1',
} as const;

export const SHARED_SERVICES_MODULE_EVIDENCE_CONTRACT =
  defineModuleEvidenceContract(
    'shared-services',
    {
      governed_snapshot: sharedServicesEvidenceEntry,
    },
    {
      evidenceKeys: Object.values(SHARED_SERVICES_EVIDENCE_KEYS),
      sourceClasses: [sharedServicesEvidenceEntry.sourceClass],
      contextKinds: [sharedServicesEvidenceEntry.contextKind],
      schemaVersions: Object.values(SHARED_SERVICES_SCHEMA_VERSIONS),
      stateKeys: Object.values(SHARED_SERVICES_STATE_KEYS),
      bindingPlaceholders: Object.values(SHARED_SERVICES_BINDING_PLACEHOLDERS),
    },
  );

export type SharedServicesModuleEvidenceContract =
  typeof SHARED_SERVICES_MODULE_EVIDENCE_CONTRACT;
